import { toZonedTime } from 'date-fns-tz';

const timeZone = 'Europe/Madrid';

export const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
};

export const minutesToTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

export const dateInSpain = (date = new Date()) => {
    return toZonedTime (date, timeZone);
};